import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/encounter-participant";

export const pagingReportParticipants = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

// Lưu các thành viên tham gia điều trị
export const saveDiagnosticReportParticipants = (dto) =>
  axios.post(API_PATH + "/save-report-participants", dto);

// Lấy thông tin các thành viên tham gia điều trị
export const getDiagnosticReportParticipant = (diagnosticReportId) =>
  axios.get(API_PATH + "/diagnostic-report-participants/" + diagnosticReportId);

// Lấy thông tin các thành viên tham gia điều trị theo ServiceRequestItem
export const getDiagnosticReportParticipantBySRIId = (serviceRequestItemId) =>
  axios.get(
    API_PATH +
      "/diagnostic-report-participants-by-sri-id/" +
      serviceRequestItemId
  );
export const updateParticipantsAndReportOfSvItem = (serviceRequestItem) =>
  axios.post(API_PATH + "/update-participants-of-sv-item", serviceRequestItem);

export const getInitSvitemParticipant = (obj) =>
  axios.post(API_PATH + "/get-init-svitem-participants", obj);

export const exportExcelMonneyTour = (obj) => {
  return axios({
    url: API_PATH + "/report-treament-monney-tour/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};
